// angular
//     .module("HeroPRO")
//     .factory("FRDisbursementsFactory", fundingRequestDisbursementsFactory);

/* @ngInject */
export default function fundingRequestDisbursementsFactory(HPConfig, $http) {
    return {
        getDisbursementStatusHistory,
    };

    function getDisbursementStatusHistory(params) {
        return $http.get(`${HPConfig.heroProApi}Loan/Disbursements/StatusHistory`, {
            params,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/appDetail/fundingRequestDisbursementsFactory.js